import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { GlassCard } from '../components/ui/GlassCard';
import { Lock } from 'lucide-react';
export function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const {
        error
      } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (error) throw error;
      navigate('/admin/dashboard');
    } catch (err: any) {
      setError(err.message);
      // For demo purposes, allow login with any credentials if Supabase fails
      // navigate('/admin/dashboard')
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-black flex items-center justify-center p-4" data-id="element-389">
      <GlassCard className="w-full max-w-md p-8 border-white/10" data-id="element-390">
        <div className="text-center mb-8" data-id="element-391">
          <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-392">
            <Lock size={24} className="text-white" data-id="element-393" />
          </div>
          <h1 className="text-2xl font-bold text-white font-special" data-id="element-394">
            Admin Login
          </h1>
        </div>

        {error && <div className="mb-4 p-3 rounded bg-red-500/10 border border-red-500/20 text-red-400 text-sm" data-id="element-395">
            {error}
          </div>}

        <form onSubmit={handleLogin} className="space-y-4" data-id="element-396">
          <div data-id="element-397">
            <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-398">
              Email
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white focus:border-cyan-500/50 focus:outline-none" required data-id="element-399" />
          </div>
          <div data-id="element-400">
            <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-401">
              Password
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white focus:border-cyan-500/50 focus:outline-none" required data-id="element-402" />
          </div>
          <button type="submit" disabled={loading} className="w-full py-2 rounded-lg bg-white text-black font-bold hover:bg-gray-200 transition-colors disabled:opacity-50" data-id="element-403">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </GlassCard>
    </div>;
}